import React, { useState } from 'react';
import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import EditTestPattern from '../CreatePages/EditTestPattern';
import './Dashboard.css';

const EditTestPatternPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
          <EditTestPattern />
        </div>
      </main>
    </div>
  );
};

export default EditTestPatternPage;